import renderQuickbooksStatusCell from "./renderQuickbooksStatusCell";
import QuickbooksActionsCell from "./QuickbooksActionsCell";

export default function renderQuickbooksCellContent(
  value,
  column,
  row,
  {
    quickbooksSyncingCustomerIds,
    quickbooksConnectingCustomerId,
    validationLoadingCustomerId,
    onConnect,
    onSync,
    onOpenMenu,
    onSyncStatusClick,
  } = {}
) {
  if (column.field === "quickbooksStatus" || column.field === "syncStatus") {
    return renderQuickbooksStatusCell({
      value,
      column,
      row,
      validationLoadingCustomerId,
      onSyncStatusClick,
    });
  }

  if (column.type === "actions") {
    const customerForAction = row?.originalCustomer || row;
    const customerId = customerForAction?.id;

    return (
      <QuickbooksActionsCell
        row={row}
        syncingCustomerIds={quickbooksSyncingCustomerIds}
        connectingCustomerId={quickbooksConnectingCustomerId}
        onConnect={onConnect}
        onSync={onSync}
        onOpenMenu={onOpenMenu}
        customerId={customerId}
      />
    );
  }

  if (value === "-" || !value) {
    return "";
  }

  return value;
}